import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const breadcrumbs = {
  namespaced: true,
  state: {
    breadcrumbs: []
  },
  getters,
  mutations,
  actions
};
